export default __webpack_public_path__ + "static/media/gallery - story - heart (1)_02.0069154e.jpg";